import axios from 'axios';

export function deleteREST(endpoint, options = { token: '', traceId: '', headers: {} }) {
    const { token, headers, traceId } = options;

    return new Promise((resolve) => {
        const reqHeaders = {
            authorization: 'Bearer ' + token,
            'x-trace-id': traceId,
            ...headers,
        };
        axios.delete(endpoint, { headers: reqHeaders })
            .then(resolve)
            .catch(resolve);
    });
}

export default deleteREST;
